import React, { Component, Fragment, createRef } from 'react';
import { ValidarUsuario, ObtenerUsuario, ValidarPermisos, LIST_SCREENS, listarPermisos, CreateJsonToExcel, listarPermisosTipoTrabajo, ObtenerDetalleToken } from '../utils/utils'
import NavBar from '../dashboard/navBar';
import TituloPagina from '../dashboard/headerTitle';
import moment from 'moment';
import { Link, Switch } from 'react-router-dom';
// import socketIOClient from 'socket.io-client';

import { Table, TableContainer, TableHead, TableCell, TableBody, TableRow, TablePagination, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Modal, Form, Spinner } from 'react-bootstrap';

import LoadingModal from './../utils/loadModal'
import SpinnerCarga from './../utils/spinner'
import config from './../../config/config';

// import { CreateJsonToExcel } from './../utils/utils'
//Crear zip y guardar
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf';
var zip = require('jszip')();

class Migracion extends Component {
    //Variables globales     
    constructor(props) {
        super(props);
        this.state = {
            OcultarLoading: true,
            colorIcon: '',
            MostrarModalCambiarTrabajador: false,
            MostrarModalMigrarFotos: false,
            MostrarModalDescargarFotoFechaEjecucion: false,
            MostrarModalReporteFechas: false,
            MostrarSnackDescargaFotos: false,
            mensajeDescargaFotos: '',
            fechaprogramacion: '',
            LoadData: false,
            ListaProgramacion: [],
            ProgramacionDetalleDia: [],
            ListaPaginacion: [],
            valorEstadoBusqueda: 'TODOS',
            ListaBusqueda: [],
            ListaSuministrosProgramadoTecnico: [],
            ListaTrabajadoresActivos: [],
            ListaSuministrosSeleccionados: [],
            TrabajoProgramadoSeleccionado: '',
            // TipoTrabajos: [],
            TiposTrabajoFechaProgramada: [],
            cantidadElementosSeleccionados: 0,
            cantidadElementos: 0,
            filasPorPagina: 50,
            pagina: 1,
            sizeWidth: 0,
            tipofiltro: 'Todos',
            valorBuscar: '',
            ProgramacionActualizada: 0,
            ProgramacionError: 0,
            mensaCargaActualizacion: '',
            MostrarPorcentajeCarga: false,
            visualizarTodosTrabajos: null,
            visualizarTiposTrabajo: null,
            idproyecto: null,
            mostrarModalReprogramar: false,
            trabajadorSeleccionado: null,
            MostrarModalReporteTipoTrabajo: false,
            permisos: [],
            mostrarspinner: false,
            datosFotosMigracion: [],
            datosPedintesMigracion: [],
            inicioMigracion: false,
            migracionEnviados: 0,
            migracionError: 0,
            mensajeMigracion: ''
        };
        // Referencias

        this.inputFechaInicio = createRef();
        this.inputFechaFin = createRef();
        this.selectTipoFiltro = createRef();
        this.inputBuscarFiltro = createRef();
        this.selectTipoTrabajo = createRef();

        // Referencias Modal Cambiar Trabajador
        this.inputNombreTrabajador = createRef();
        this.inputElegirTrabajador = createRef();
        this.inputFechaReprogramar = createRef();
        this.inputChecktodosLosElementos = createRef();
        this.listarFotosProgramacion = [];

        //Referencias modal Descargar
        this.selectTipoTrabajoDescargar = createRef();
        this.checkRotularFotoDescarga = createRef();

        //Referencias Modal Reporte Fechas
        this.inputFechaInicioReporteFecha = createRef();
        this.inputFechaFinReporteFecha = createRef();


        this.tableBodySuministros = createRef();
        this.headCells = [
            { id: 'Foto' },
            { id: 'Fecha' },
            { id: 'Estado M.' },
            { id: 'Fecha Migracion' },
            { id: 'Origen' },
        ];
        //Inicializar Valores de Servidor Socket
        // this.socket=socketIOClient(config.endPoint,{transports: ['websocket', 'polling', 'flashsocket']});     

    }

    async componentDidMount() {
        if (ValidarUsuario()) {
            listarPermisos().then(async (permisos) => {
                // console.log(permisos);
                this.setState({ permisos: permisos });

                await listarPermisosTipoTrabajo().then(async (respuesta) => {
                    if (respuesta) {
                        await this.setState({ visualizarTodosTrabajos: respuesta.visualizartodostrabajos, visualizarTiposTrabajo: respuesta.visualizarportipotrabajos });
                    }
                });

                if (ValidarPermisos(LIST_SCREENS.ACCESS_SCREEN_CONFIG_MIGRACION, permisos)) {

                    let UsuarioStorage = ObtenerUsuario();
                    UsuarioStorage = JSON.parse(UsuarioStorage);
                    if (UsuarioStorage.token) {
                        let DetalleToken = JSON.parse(ObtenerDetalleToken(UsuarioStorage.token));
                        if (DetalleToken.idproyecto) {
                            this.setState({ idproyecto: DetalleToken.idproyecto });
                        }
                    }
                    // Llenar los cuadros y llamar a la APi                                            
                    this.inputFechaInicio.current.value = moment().format('YYYY-MM-DD');
                    this.inputFechaFin.current.value = moment().format('YYYY-MM-DD');


                    this.setState({ OcultarLoading: true, LoadData: true });
                    // await this.BuscarFotosMigracionfecha();
                    // await this.SocketConcect();

                } else {
                    this.setState({ abrirToast: true, mensajeToast: "No tiene permisos para acceder a este Recurso", tipotoast: 'warning' });
                    setTimeout(() => {
                        this.props.history.push('/login');
                    }, 1000);
                }

            });


        }
        else {
            //Redireccionando a Login
            this.props.history.push('/login');
        }
    }


    BuscarFotosMigracionfecha = async () => {
        if (ValidarUsuario()) {

            // let fecha = moment(this.inputfechaProgramacion.current.value).format('YYYY-MM-DD');
            this.setState({ LoadData: false });
            let UsuarioStorage = ObtenerUsuario();
            UsuarioStorage = JSON.parse(UsuarioStorage);

            let headers = {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + UsuarioStorage.token,
                }
            };
            let url = `${config.endPoint}api/foto/listarMigrar/${this.inputFechaInicio.current.value}/${this.inputFechaFin.current.value}`;

            await fetch(url, headers).then((respuesta) => {
                return respuesta.json();
            }).then(async (data) => {
                // console.log(data);
                if (data.content) {
                    await this.setState({ datosFotosMigracion: data.content, cantidadElementos: data.content.length, LoadData: true });
                    this.Paginacion();
                }
                else {
                    this.setState({ datosFotosMigracion: [], cantidadElementos: 0, LoadData: true });
                }
            }).catch((error) => {
                // console.log();
                this.setState({ mensajeToast: config.MessageErrorServer, abrirToast: true, tipotoast: 'error' });
            });
        }
        else {
            this.props.history.push('/login');
        }
    }

    BuscarFotosPendientesMigracionfecha = async () => {
        if (ValidarUsuario()) {

            // let fecha = moment(this.inputfechaProgramacion.current.value).format('YYYY-MM-DD');
            this.setState({ OcultarLoading: false });
            let UsuarioStorage = ObtenerUsuario();
            UsuarioStorage = JSON.parse(UsuarioStorage);

            let headers = {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + UsuarioStorage.token,
                }
            };
            let url = `${config.endPoint}api/foto/listarPendientesMigrar/${this.inputFechaInicio.current.value}/${this.inputFechaFin.current.value}`;
            // console.log(url);

            await fetch(url, headers).then((respuesta) => {
                return respuesta.json();
            }).then(async (data) => {
                // console.log(data);
                if (data.content) {
                    await this.setState({ datosPedintesMigracion: data.content });
                    this.AbrirModalMigrarFotos();
                }
                else {
                    this.setState({ datosPedintesMigracion: [] });
                }
                this.setState({ OcultarLoading: true });
            }).catch((error) => {
                // console.log();
                this.setState({ mensajeToast: config.MessageErrorServer, abrirToast: true, tipotoast: 'error' });
            });
        }
        else {
            this.props.history.push('/login');
        }
    }


    AbrirModalMigrarFotos = () => {
        this.setState({ MostrarModalMigrarFotos: true, migracionEnviados: 0, migracionError: 0 });
    }
    CerrarModalMigrarFotos = () => {
        this.setState({ MostrarModalMigrarFotos: false });
    }

    CambiarFecha = async () => {
        this.selectTipoFiltro.current.value = "Todos";
        await this.setState({ fechaprogramacion: this.inputfechaProgramacion.current.value, LoadData: false, tipofiltro: this.selectTipoFiltro.current.value, TrabajoProgramadoSeleccionado: '' });
        await localStorage.setItem(config.storageDateName, this.state.fechaprogramacion);
        this.selectTipoTrabajo.current.value = 'Todos';
        await localStorage.removeItem(config.storageFilterTrabajo);
        await this.BuscarProgramacionfecha();
    }
    CambioSelectTipoFiltro = async () => {

        await this.setState({ LoadData: false, tipofiltro: this.selectTipoFiltro.current.value, valorBuscar: '' });
        let UsuarioStorage = ObtenerUsuario();
        UsuarioStorage = JSON.parse(UsuarioStorage);
        let headers = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + UsuarioStorage.token,
            }
        };

        switch (this.state.tipofiltro) {
            case 'Trabajador':
                // Buscar Lista de Trabajadores
                let urlTrabajadores = `${config.endPoint}api/trabajosuministro/listarNombres/trabajador/${this.state.idproyecto}/${this.state.fechaprogramacion}`;
                fetch(urlTrabajadores, headers).then((respuesta) => {
                    return respuesta.json();
                }).then((data) => {
                    if (data.content) {
                        this.setState({ ListaBusqueda: data.content });
                    }
                });
                this.inputBuscarFiltro.current.value = "";
                break;
            case 'Supervisor':
                // Buscar Lista de Supervisores
                let urlSupervisores = `${config.endPoint}api/trabajosuministro/listarNombres/supervisor/${this.state.idproyecto}/${this.state.fechaprogramacion}`;
                fetch(urlSupervisores, headers).then((respuesta) => {
                    return respuesta.json();
                }).then((data) => {
                    if (data.content) {
                        this.setState({ ListaBusqueda: data.content });
                    }
                });
                this.inputBuscarFiltro.current.value = "";
                break;
            case 'Estado':
                let nuevoArray = [];
                for (let x = 0; x < this.state.ListaProgramacion.length; x++) {
                    let existe = false;
                    for (let y = 0; y < nuevoArray.length; y++) {
                        if (this.state.ListaProgramacion[x].estado === nuevoArray[y].nombretrabajador) {
                            existe = true;
                            break;
                        }
                    }
                    if (!existe) {
                        nuevoArray.push({ nombretrabajador: this.state.ListaProgramacion[x].estado });
                    }
                }
                this.setState({ ListaBusqueda: nuevoArray });
                this.inputBuscarFiltro.current.value = "";
                break;
            default:
                this.setState({ ListaBusqueda: [] });
        }
        await this.BuscarProgramacionfecha();
    }
    KeyEnterInputBuscar = async (ev) => {
        if (ev.key === "Enter") {
            await this.setState({ LoadData: false, pagina: 1, valorBuscar: this.inputBuscarFiltro.current.value });
            await this.BuscarProgramacionfecha();
        }
    }
    cambioFiltroBuscar = async (ev) => {
        if (ev.target.value === "") {
            await this.setState({ LoadData: false, pagina: 1, valorBuscar: this.inputBuscarFiltro.current.value });
            await this.BuscarProgramacionfecha();
        }
    }
    //*************************************************
    //Funciones para Paginacion
    //*************************************************
    Paginacion = async () => {
        let filainicio = 0;
        if (this.state.datosFotosMigracion.length > 0) {
            filainicio = parseInt(this.state.filasPorPagina) * (parseInt(this.state.pagina) - 1);
        }
        let filafin = filainicio + this.state.filasPorPagina;
        let nuevoArray = [];
        for (let x = filainicio; x < this.state.datosFotosMigracion.length; x++) {
            if (x < filafin) {
                nuevoArray.push(this.state.datosFotosMigracion[x]);
            }
        }
        await this.setState({ ListaPaginacion: nuevoArray, LoadData: true });
    }
    CambioFilasPorPagina = async (event) => {
        await this.setState({ LoadData: false, filasPorPagina: parseInt(event.target.value), pagina: 1 });
        await this.BuscarFotosMigracionfecha();
    }
    CambiarPagina = async (event, nuevaPagina) => {
        await this.setState({ LoadData: false, pagina: (parseInt(nuevaPagina) + 1) });
        await this.BuscarFotosMigracionfecha();
    }

    MigrarFotos = async () => {
        try {
            const { datosPedintesMigracion } = this.state;

            if (datosPedintesMigracion.length === 0) {
                this.setState({
                    mensajeToast: "No se encontraron datos para migrar.",
                    abrirToast: true,
                    tipotoast: 'error'
                });
                return;
            }

            // Iniciar migración
            this.setState({
                inicioMigracion: true,
                migracionEnviados: 0,
                migracionError: 0
            });

            let migracionEnviados = 0;
            let migracionError = 0;

            for (let x = 0; x < datosPedintesMigracion.length; x++) {
                const foto = datosPedintesMigracion[x];
                const url = `${config.endPoint}api/foto/MigrarFoto`;

                const UsuarioStorage = ObtenerUsuario();
                const token = JSON.parse(UsuarioStorage).token;

                try {
                    const respuesta = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + UsuarioStorage.token,
                        },
                        body: JSON.stringify({
                            idfoto:foto.idfoto,
                            filename:foto.foto_url
                        })
                    });

                    const data = await respuesta.json();

                    if (data.messaje === "Enviado" || data.success) {
                        migracionEnviados++;
                    } else {
                        migracionError++;
                    }

                    // Actualizar estado después de cada foto
                    this.setState({
                        migracionEnviados,
                        migracionError
                    });

                } catch (error) {
                    console.error("Error al migrar foto:", error);
                    migracionError++;
                    this.setState({ migracionError });
                }
            }

            // Finalizar migración
            this.setState({
                inicioMigracion: false,
                mensajeToast: `Migración terminada. Éxitos: ${migracionEnviados}, Errores: ${migracionError}`,
                tipotoast: migracionError > 0 ? 'warning' : 'success',
                abrirToast: true
            });
            this.CerrarModalMigrarFotos()

        } catch (error) {
            this.setState({
                mensajeToast: "Ocurrió un error al iniciar la migración.",
                tipotoast: 'error',
                abrirToast: true,
                inicioMigracion: false
            });
        }
    }
    // RevisarMigrarFotos = async () => {
    //     try {
    //         const { datosPedintesMigracion } = this.state;

    //         if (datosPedintesMigracion.length === 0) {
    //             this.setState({
    //                 mensajeToast: "No se encontraron datos para migrar.",
    //                 abrirToast: true,
    //                 tipotoast: 'error'
    //             });
    //             return;
    //         }

    //         // Iniciar migración
    //         this.setState({
    //             inicioMigracion: true,
    //             migracionEnviados: 0,
    //             migracionError: 0
    //         });

    //         let migracionEnviados = 0;
    //         let migracionError = 0;

    //         for (let x = 0; x < datosPedintesMigracion.length; x++) {
    //             const foto = datosPedintesMigracion[x];
    //             const url = `${config.endPoint}api/foto/RevisarMigrarFoto`;

    //             const UsuarioStorage = ObtenerUsuario();
    //             const token = JSON.parse(UsuarioStorage).token;

    //             try {
    //                 const respuesta = await fetch(url, {
    //                     method: 'POST',
    //                     headers: {
    //                         'Accept': 'application/json',
    //                         'Content-Type': 'application/json',
    //                         'Authorization': 'Bearer ' + UsuarioStorage.token,
    //                     },
    //                     body: JSON.stringify({
    //                         idfoto:foto.idfoto,
    //                         filename:foto.foto_url
    //                     })
    //                 });

    //                 const data = await respuesta.json();

    //                 if ( data.success) {
    //                     migracionEnviados++;
    //                 } else {
    //                     migracionError++;
    //                 }

    //                 // Actualizar estado después de cada foto
    //                 this.setState({
    //                     migracionEnviados,
    //                     migracionError
    //                 });

    //             } catch (error) {
    //                 console.error("Error al migrar foto:", error);
    //                 migracionError++;
    //                 this.setState({ migracionError });
    //             }
    //         }

    //         // Finalizar migración
    //         this.setState({
    //             inicioMigracion: false,
    //             mensajeToast: `Migración terminada. Éxitos: ${migracionEnviados}, Errores: ${migracionError}`,
    //             tipotoast: migracionError > 0 ? 'warning' : 'success',
    //             abrirToast: true
    //         });
    //         this.CerrarModalMigrarFotos()

    //     } catch (error) {
    //         this.setState({
    //             mensajeToast: "Ocurrió un error al iniciar la migración.",
    //             tipotoast: 'error',
    //             abrirToast: true,
    //             inicioMigracion: false
    //         });
    //     }
    // }
    RevisarMigrarFotos = async () => {
        try {
            const { datosPedintesMigracion } = this.state;
    
            if (!datosPedintesMigracion.length) {
                this.setState({
                    mensajeToast: "No se encontraron datos para migrar.",
                    abrirToast: true,
                    tipotoast: 'error'
                });
                return;
            }
    
            this.setState({
                inicioMigracion: true,
                migracionEnviados: 0,
                migracionError: 0
            });
    
            // Función auxiliar para procesar un solo archivo
            const procesarFoto = async (foto: any): Promise<boolean> => {
                const url = `${config.endPoint}api/foto/RevisarMigrarFoto`;
                const UsuarioStorage = ObtenerUsuario();
                const token = JSON.parse(UsuarioStorage).token;
    
                try {
                    const respuesta = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        },
                        body: JSON.stringify({
                            idfoto: foto.idfoto,
                            filename: foto.foto_url
                        })
                    });
    
                    const data = await respuesta.json();
    
                    return data.success;
                } catch (error) {
                    console.error("Error al migrar:", error);
                    return false;
                }
            };
    
            // Función para procesar en lotes
            const procesarEnLotes = async (fotos: any[], tamañoLote = 200) => {
                let migracionEnviados = this.state.migracionEnviados || 0;
                let migracionError = this.state.migracionError || 0;
    
                for (let i = 0; i < fotos.length; i += tamañoLote) {
                    const lote = fotos.slice(i, i + tamañoLote);
    
                    const resultados = await Promise.all(
                        lote.map(foto => procesarFoto(foto))
                    );
    
                    // Contar éxito/error en este lote
                    const exitos = resultados.filter(r => r).length;
                    const errores = resultados.filter(r => !r).length;
    
                    migracionEnviados += exitos;
                    migracionError += errores;
    
                    // Actualizar UI
                    this.setState({
                        migracionEnviados,
                        migracionError,
                        mensajeToast: `Procesado ${i + lote.length} de ${fotos.length}`,
                        tipotoast: 'success',
                        abrirToast: true
                    });
    
                    // Pausa opcional para evitar sobrecarga
                    await new Promise(resolve => setTimeout(resolve, 20));
                }
    
                this.setState({
                    inicioMigracion: false,
                    mensajeToast: `✅ Migración terminada. Éxitos: ${migracionEnviados}, Errores: ${migracionError}`,
                    tipotoast: migracionError > 0 ? 'warning' : 'success',
                    abrirToast: true
                });
    
                this.CerrarModalMigrarFotos();
            };
    
            // Iniciar migración por lotes
            await procesarEnLotes(datosPedintesMigracion, 200);
    
        } catch (error) {
            this.setState({
                mensajeToast: "Ocurrió un error al iniciar la migración",
                tipotoast: 'error',
                abrirToast: true,
                inicioMigracion: false
            });
        }
    };

    EliminarArchivosMigrados = async () => {
        if (ValidarUsuario()) {

            // let fecha = moment(this.inputfechaProgramacion.current.value).format('YYYY-MM-DD');
            this.setState({ OcultarLoading: false });
            let UsuarioStorage = ObtenerUsuario();
            UsuarioStorage = JSON.parse(UsuarioStorage);

            let headers = {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + UsuarioStorage.token,
                }
            };
            let url = `${config.endPoint}api/foto/eliminarFotosMigradas/${this.inputFechaInicio.current.value}/${this.inputFechaFin.current.value}`;

            await fetch(url, headers).then((respuesta) => {
                return respuesta.json();
            }).then(async (data) => {
                // console.log(data);                                
                if (data) {
                    this.setState({ mensajeToast: `${data.message} \nTotal Archivos ${data.totalRevisados}, Total Eliminados:${data.eliminados}, `, abrirToast: true, tipotoast: 'success' });
                }
                this.setState({ OcultarLoading: true });
            }).catch((error) => {
                // console.log();
                this.setState({ mensajeToast: config.MessageErrorServer, abrirToast: true, tipotoast: 'error' });
            });
        }
        else {
            this.props.history.push('/login');
        }
    }

    //*************************************************
    // Funciones para toast
    //*************************************************
    CerrarToastNotification = () => {
        this.setState({ abrirToast: false });
    }

    render() {

        return (
            <Fragment>
                <Snackbar
                    open={this.state.MostrarPorcentajeCarga}
                    message={this.state.mensaCargaActualizacion}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                />
                {/* Modal de Carga */}
                <div hidden={this.state.OcultarLoading}>
                    <LoadingModal />
                </div>

                {/* ************************************************* */}
                {/* TOAST ALERT */}
                {/* ************************************************* */}
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={this.state.abrirToast} autoHideDuration={4000} onClose={this.CerrarToastNotification}>
                    <Alert onClose={this.CerrarToastNotification} variant='filled' severity={this.state.tipotoast}>
                        {this.state.mensajeToast}
                    </Alert>
                </Snackbar>
                {/* ************************************************* */}
                {/* Snack Carga */}
                {/* ************************************************* */}
                <Snackbar
                    open={this.state.MostrarSnackDescargaFotos}
                    message={this.state.mensajeDescargaFotos}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                />

                <NavBar CerrarSesion={this.CerrarSesion} />
                {/* <TituloPagina titulo={`MONITOREO ${this.state.TrabajoProgramadoSeleccionado}`} regresar={() => { this.props.history.push('/operacionesComerciales') }}></TituloPagina> */}
                <TituloPagina titulo={`MIGRACION DE ARCHIVOS ${this.state.TrabajoProgramadoSeleccionado}`} regresar={() => { this.props.history.push('/') }}></TituloPagina>

                {/* Contenedor de Datos */}
                <div className="container border mt-1">
                    <div className="row mt-1">
                        <div className="col-md-6 col-lg-3">
                            <input className="form-control form-control-sm p-1" type="date" placeholder="Fecha" ref={this.inputFechaInicio}></input>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <input className="form-control form-control-sm p-1" type="date" placeholder="Fecha" ref={this.inputFechaFin}></input>
                        </div>

                        <div className=" col-md-6 col-lg-3 mt-1 mt-md-0">
                            <button onClick={() => { this.BuscarFotosMigracionfecha() }} type="button" class="btn btn-primary btn-sm">Buscar</button>
                        </div>



                        <div className={this.state.tipofiltro !== "Todos" ? "col-md-12 text-end mt-1 mt-md-0" : "col-md-6 col-lg-3 text-end mt-1 mt-md-0"} >
                            <div className="dropdown">
                                <button className="btn btn-sm dropdown-toggle" type="button" id="ListaMenuAcciones" data-bs-toggle="dropdown" aria-expanded="false">
                                    Opciones
                                </button>
                                <ul className="dropdown-menu dropdown-menu-light" aria-labelledby="ListaMenuAcciones">
                                    <li onClick={() => { this.BuscarFotosPendientesMigracionfecha() }}><small className="dropdown-item" ><i className="fas fa-calendar-check mx-2"></i>Migrar Fotos</small></li>
                                    <li onClick={() => { this.EliminarArchivosMigrados() }}><small className="dropdown-item" ><i className="fas fa-calendar-check mx-2"></i>Eliminar archivos Migrados AWS</small></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row p-1">
                        {
                            this.state.LoadData ?
                                <>
                                    {/* Tabla Aqui */}
                                    <TableContainer style={{ maxHeight: window.outerHeight < 760 ? 430 : 650 }}>
                                        <Table size='small' stickyHeader>
                                            <TableHead>
                                                <TableRow className="fondoTituloTabla">
                                                    {
                                                        this.headCells.map((head, index) => {
                                                            return (
                                                                <TableCell
                                                                    // style={{ color: 'aliceblue' }} 
                                                                    key={index}>{head.id}</TableCell>
                                                            );
                                                        })
                                                    }

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.ListaPaginacion.map((row, index) => {

                                                    return (
                                                        <TableRow key={index}>
                                                            {/* <TableCell style={{ fontSize: '0.75em' }}>
                                                                <i onClick={() => { this.AbrirModalCambiarTrabajador(row) }} title="Modificar" className="fas fa-edit  iconoAcciones" ></i>
                                                            </TableCell> */}
                                                            {/* <TableCell style={{ fontSize: '0.75em' }}>
                                                                <i onClick={() => { this.AbrirModalReprogramarPendientes(row) }} title='Reprogramar' className="fas fa-retweet iconoAcciones"></i>
                                                            </TableCell> */}
                                                            <TableCell style={{ fontSize: '0.75em' }}>{row.foto_url}</TableCell>
                                                            <TableCell style={{ fontSize: '0.75em' }}>{row.fecha}</TableCell>
                                                            <TableCell style={{ fontSize: '0.75em' }} className={row.estadoMigracion == 'MIGRADO' ? 'text-success' : 'text-danger'}>{row.estadoMigracion}</TableCell>
                                                            <TableCell style={{ fontSize: '0.75em' }}>{row.fechaMigracion ? moment(row.fechaMigracion).format('YYYY-mm-DD HH:MM:SS') : ''}</TableCell>
                                                            <TableCell style={{ fontSize: '0.75em' }}>{row.origenFoto}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15, 25, 50]}
                                        component="div"
                                        count={this.state.cantidadElementos}
                                        rowsPerPage={this.state.filasPorPagina}
                                        page={this.state.pagina - 1}
                                        onChangePage={this.CambiarPagina}
                                        onChangeRowsPerPage={this.CambioFilasPorPagina}
                                        labelRowsPerPage={"Filas Por Pagina"}
                                    />
                                </>
                                :
                                <SpinnerCarga />

                        }
                    </div>

                </div>


                {/* Modal Migrar Fotos */}
                <Modal
                    show={this.state.MostrarModalMigrarFotos}
                    onHide={() => this.CerrarModalMigrarFotos()}
                    backdrop="static"
                    keyboard={false}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Migrar Fotografías</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        {/* Contador de fotos */}
                        <div className="mb-3">
                            <h5>Migrando {this.state.migracionEnviados} de {this.state.datosPedintesMigracion.length}</h5>
                            <p>
                                <span className="text-success">Correctas: {this.state.migracionEnviados}</span> |
                                <span className="text-danger ms-2">Errores: {this.state.migracionError}</span>
                            </p>
                        </div>

                        {/* Spinner central */}
                        {this.state.inicioMigracion ? (
                            <div className="d-flex justify-content-center align-items-center my-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </div>
                                <span className="ms-3">Procesando imágenes...</span>
                            </div>
                        ) : (
                            <p className="text-muted">Haz clic en "Iniciar Migración" para comenzar.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-end">
                            <button
                                disabled={this.state.inicioMigracion || this.state.mostrarspinner}
                                onClick={this.MigrarFotos}
                                className="btn btn-primary"
                            >
                                {this.state.inicioMigracion || this.state.mostrarspinner ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Procesando...
                                    </>
                                ) : 'Iniciar Migración'}
                            </button>
                            <button
                                disabled={this.state.inicioMigracion || this.state.mostrarspinner}
                                onClick={this.RevisarMigrarFotos}
                                className="btn btn-primary"
                            >
                                {this.state.inicioMigracion || this.state.mostrarspinner ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Procesando...
                                    </>
                                ) : 'Revisar Migración'}
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

            </Fragment>
        );



    }
}

export default Migracion;